import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../shared/services/auth.service';
import { logoBlack } from '../../utils/images';
import appConfig from '../../shared/config/app-config';

@Component({
  selector: 'header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent {
  constructor(private authService: AuthService, private router: Router) {}
  user: any = this.authService.currentUserValue?.profile;
  isLoggedIn: boolean = this.authService.getToken;
  get isOnLoginPage(): boolean {
    return this.router.url === '/login' || this.router.url.startsWith('/login?');
  }
  get isOnRegisterPage(): boolean {
    return this.router.url === '/register' || this.router.url.startsWith('/register?');
  }
  logoBlack = logoBlack
  vettimesUrl = appConfig.vettimesUrl
  allJobsUrl = appConfig.allJobsUrl
  myJobsUrl = appConfig.myJobsUrl
  recruitersUrl = appConfig.recruitersUrl
}
